import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { price } from 'researcher/helpers/price';
import { stickySidebarOffset } from 'researcher/helpers/sticky';
import { T } from 'shared/helper/translate';
var InvoicePaymentSidebar = function InvoicePaymentSidebar(_ref) {
  var currency = _ref.currency,
    formData = _ref.formData,
    paymentCurrencyMatchesInvoiceCurrency = _ref.paymentCurrencyMatchesInvoiceCurrency,
    status = _ref.status,
    submitForm = _ref.submitForm,
    total = _ref.total,
    unpaidInvoices = _ref.unpaidInvoices,
    usdTotal = _ref.usdTotal;
  var buttonDisabled = typeof formData.paymentMethodId !== 'undefined' && formData.paymentMethodId === '' || status.loading || status.saving;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-4 col-12 summary new-button-styles mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "invoice-payment-sidebar",
    style: {
      top: "".concat(stickySidebarOffset(35), "px")
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "order-details-content"
  }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement(T, {
    source: "Payoff summary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "order-section"
  }, /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement(T, {
    source: "Unpaid invoices"
  })), unpaidInvoices.map(function (unpaidInvoice) {
    return /*#__PURE__*/React.createElement("div", {
      key: unpaidInvoice.invoiceNumber,
      className: "pt-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "float-end"
    }, price(currency, paymentCurrencyMatchesInvoiceCurrency ? unpaidInvoice.balance : unpaidInvoice.usdBalance, true, !paymentCurrencyMatchesInvoiceCurrency)), unpaidInvoice.invoiceNumber);
  })), total > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "order-total order-section borderless"
  }, /*#__PURE__*/React.createElement("span", {
    className: "float-end"
  }, price(currency, paymentCurrencyMatchesInvoiceCurrency ? total : usdTotal, true, !paymentCurrencyMatchesInvoiceCurrency)), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Total"
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: "mt-3 ps-4 pe-4"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: buttonDisabled,
    className: "btn btn-success btn-squared-large w-100".concat(buttonDisabled ? ' disabled' : ''),
    onClick: submitForm
  }, status.loading || status.saving ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, {
    source: "Loading..."
  }), " ", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  })) : /*#__PURE__*/React.createElement(T, {
    source: "Pay now"
  }))))));
};
export default InvoicePaymentSidebar;